import { render } from "./Historial.vue?vue&type=template&id=5f255842"
import script from "./Historial.vue?vue&type=script&lang=js"
export * from "./Historial.vue?vue&type=script&lang=js"

import "./Historial.vue?vue&type=style&index=0&id=5f255842&lang=scss"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__